/**
 * This file is auto-generated from StateInput.loc.yaml
 * Do not edit this file directly. Edit the source file instead.
 */

import type { Translation } from '@nzyme/i18n-core';

export const stateLabel: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'State';
        case 'pl':
            return 'Stan / Region';
    }
};

export const statePlaceholder: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Enter state or region';
        case 'pl':
            return 'Wpisz stan lub region';
    }
};

export const selectState: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Select a state';
        case 'pl':
            return 'Wybierz stan';
    }
};
